export const SET_FREE_SHIPPING_OPTIONS = 'SET_FREE_SHIPPING_OPTIONS';
